import React from "react";
import { useContext, useEffect } from "react";
import { Control, useWatch } from "react-hook-form";
import { enrollmentContext } from "../../../context/enrollment/enrollment-context";
import { updateValue } from "../common-functions";

type FormUpdaterProps = {
	controlName: string;
	control: Control;
};
export const FormUpdater = ({ controlName, control }: FormUpdaterProps) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	const watch = useWatch({ name: controlName, control });
	useEffect(() => {
		updateValue(enrollmentCtxt, controlName, watch);
	}, [watch]);
	return <></>;
};
